import { FetchContext, responseErrorHandler } from '..';
import { RoleName } from '../../models';

export const startUserImpersonation: (
  fetchContext: FetchContext,
  role: RoleName,
  accessToken?: string,
) => Promise<void> = (fetchContext, role, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/user-impersonations/me`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(role),
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'start user impersonation'));
